<template>
  <VPopup
    :target="target"
    show-pointer
    align="right"
    :visible="true"
    @close="$core.dialogs.OrderCurrencyRatesPopup.hide()"
  >
    <dl id="order-currency-rates">
      <div
        v-for="([code, rate]) in Array.from(currencyRateList)"
        :key="code"
      >
        <dt>{{ code }}</dt> <dd>{{ rate.format() }} {{ order.accountingCurrency.symbol }}</dd>
      </div>
    </dl>
  </VPopup>
</template>

<style lang="scss" src="./OrderCurrencyRatesPopup.scss" />

<script lang="ts">
import Order              from "@/domains/Orders/Order";
import type CurrencyRate  from "@/core/types/CurrencyRate";

export default defineComponent({
  name: 'OrderCurrencyRatesPopup',

  emits: ['close'],

  props: {
    order: {
      type: Object as PropType<Order>,
      required: true,
    },
    target: {
      type: HTMLElement,
      default: null,
    },
  },

  computed: {
    /**
     * Курсы валют позиций к валюте учёта на дату документа. Дата та же, по
     * которой считаются суммы заказа — иначе попап показал бы курс, к
     * которому итог в шапке отношения не имеет.
     *
     * Валюты без курса в список не попадают: печатать нечего.
     */
    currencyRateList(): Map<string, CurrencyRate> {
      const result = new Map<string, CurrencyRate>();

      this.order.positions.forEach((position) => {
        if (result.has(position.currencyCode) === true) {
          // Валюта уже в списке
        }
        else {
          const rate = this.$core.currencies.getRateCached(position.currencyCode, this.order.createdAt);

          if (rate === null) {
            // Курса нет — строку не показываем
          }
          else {
            result.set(position.currencyCode, rate);
          }
        }
      });

      return result;
    },
  }
});
</script>
